var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1024 12L28.0274 12C29.1168 12 30 12.8832 30 13.9726V28.0274C30 29.1168 29.1168 30 28.0274 30H18.1024M18.1024 12L13.9726 12C12.8832 12 12 12.8832 12 13.9726L12 28.0274C12 29.1168 12.8832 30 13.9726 30H18.1024M18.1024 12V30M24.1127 12V30",
    stroke: "#898E99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddColumn);
export default __webpack_public_path__ + "static/media/add_column.0a6ca12c7341633fbcbb353067989f7e.svg";
export { ForwardRef as ReactComponent };